(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (() => {
    const iniciarMegamenusHiran = (contenedor) => {
      const raiz = contenedor || document;
      const detalles = raiz.querySelectorAll('.hiran-mega');

      detalles.forEach((detalle) => {
        if (detalle.dataset.hiranHoverIniciado === 'true') return;
        detalle.dataset.hiranHoverIniciado = 'true';

        const resumen = detalle.querySelector(':scope > summary[data-hiran-mega-enlace]');
        let temporizadorCierre;

        const abrir = () => {
          window.clearTimeout(temporizadorCierre);
          detalles.forEach((otroDetalle) => {
            if (otroDetalle !== detalle) otroDetalle.removeAttribute('open');
          });
          detalle.setAttribute('open', '');
        };

        const programarCierre = () => {
          window.clearTimeout(temporizadorCierre);
          temporizadorCierre = window.setTimeout(() => {
            detalle.removeAttribute('open');
          }, 140);
        };

        detalle.addEventListener('mouseenter', abrir);
        detalle.addEventListener('mouseleave', programarCierre);

        resumen?.addEventListener('click', (evento) => {
          if (window.matchMedia('(min-width: 990px)').matches) {
            evento.preventDefault();
            abrir();
            const destino = resumen.dataset.hiranMegaEnlace;
            if (destino) window.location.assign(destino);
          }
        });
      });
    };

    iniciarMegamenusHiran(document);

    document.addEventListener('shopify:section:load', (evento) => {
      iniciarMegamenusHiran(evento.target);
    });
  })();

  (() => {
    const iniciarContadoresHiran = (contenedor = document) => {
      contenedor.querySelectorAll('[data-hiran-countdown]').forEach((contador) => {
        if (contador.dataset.hiranCountdownReady === 'true') return;
        contador.dataset.hiranCountdownReady = 'true';

        const salida = contador.querySelector('[data-hiran-countdown-time]');
        const fecha = contador.dataset.endDate?.trim();
        const hora = contador.dataset.endTime?.trim() || '23:59';
        const zona = contador.dataset.utcOffset?.trim() || '-06:00';
        const fechaFinal = new Date(`${fecha}T${hora}:00${zona}`);

        if (!salida || Number.isNaN(fechaFinal.getTime())) {
          if (window.Shopify?.designMode && salida) salida.textContent = 'CONFIGURA LA FECHA';
          else {
            contador.hidden = true;
            contador.closest('.header-wrapper')?.classList.remove('hiran-header--con-contador');
          }
          return;
        }

        const dosDigitos = (valor) => String(valor).padStart(2, '0');

        const actualizar = () => {
          const restante = fechaFinal.getTime() - Date.now();

          if (restante <= 0) {
            window.clearInterval(contador.hiranCountdownInterval);
            if (window.Shopify?.designMode) salida.textContent = 'FINALIZADO';
            else {
              contador.hidden = true;
              contador.closest('.header-wrapper')?.classList.remove('hiran-header--con-contador');
            }
            return false;
          }

          const dias = Math.floor(restante / 86400000);
          const horas = Math.floor((restante % 86400000) / 3600000);
          const minutos = Math.floor((restante % 3600000) / 60000);
          const segundos = Math.floor((restante % 60000) / 1000);

          salida.textContent = `${dosDigitos(dias)}D · ${dosDigitos(horas)}H · ${dosDigitos(minutos)}M · ${dosDigitos(segundos)}S`;
          salida.setAttribute('aria-label', `${dias} días, ${horas} horas, ${minutos} minutos y ${segundos} segundos`);
          return true;
        };

        if (actualizar()) contador.hiranCountdownInterval = window.setInterval(actualizar, 1000);
      });
    };

    iniciarContadoresHiran();

    document.addEventListener('shopify:section:load', (evento) => {
      iniciarContadoresHiran(evento.target);
    });

    document.addEventListener('shopify:section:unload', (evento) => {
      evento.target.querySelectorAll('[data-hiran-countdown]').forEach((contador) => {
        window.clearInterval(contador.hiranCountdownInterval);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hirannoir-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initPopup = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const enabled = root.dataset.enabled === 'true';
      const editorMode = root.dataset.editorMode === 'true';
      const windowElement = root.querySelector('.hn-popup__window');
      const closeButtons = root.querySelectorAll('[data-hn-close]');
      const form = root.querySelector('form');
      const storageKey = root.dataset.storageKey;
      const sessionKey = root.dataset.sessionKey;
      const subscriberKey = root.dataset.subscriberKey;
      const customerSubscribed = root.dataset.customerSubscribed === 'true';
      const delay = Number(root.dataset.delay || 0);
      let lastFocusedElement = null;
      let showTimer = null;

      const wasSeenThisVisit = () => {
        try {
          return sessionStorage.getItem(sessionKey) === 'true';
        } catch (error) {
          return false;
        }
      };

      const rememberThisVisit = () => {
        try {
          sessionStorage.setItem(sessionKey, 'true');
        } catch (error) {
          // El popup seguirá funcionando aunque el navegador bloquee sessionStorage.
        }
      };

      const rememberSubscription = () => {
        try {
          localStorage.setItem(subscriberKey, 'true');
        } catch (error) {
          // El popup seguirá funcionando aunque el navegador bloquee localStorage.
        }
      };

      const isKnownSubscriber = () => {
        if (customerSubscribed) return true;
        try {
          return localStorage.getItem(subscriberKey) === 'true';
        } catch (error) {
          return false;
        }
      };

      const canShow = () => {
        if (editorMode) return true;
        if (!enabled) return false;
        if (isKnownSubscriber()) return false;
        if (wasSeenThisVisit()) return false;
        return true;
      };

      const openPopup = (force = false) => {
        if (!force && !canShow()) return;
        if (!force && !editorMode) rememberThisVisit();
        lastFocusedElement = document.activeElement;
        root.classList.add('is-visible');
        root.setAttribute('aria-hidden', 'false');
        document.body.classList.add('hn-popup-open');
        windowElement.focus({ preventScroll: true });
      };

      const closePopup = (remember = true) => {
        root.classList.remove('is-visible');
        root.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('hn-popup-open');
        if (remember && !editorMode) rememberThisVisit();
        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus({ preventScroll: true });
        }
      };

      closeButtons.forEach((button) => {
        button.addEventListener('click', () => closePopup(true));
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closePopup(true);
          return;
        }

        if (event.key !== 'Tab' || !root.classList.contains('is-visible')) return;

        const focusable = Array.from(
          windowElement.querySelectorAll(
            'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href]'
          )
        ).filter((element) => element.offsetParent !== null);

        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      if (form) {
        form.addEventListener('submit', () => {
          rememberThisVisit();
          try {
            localStorage.setItem(storageKey, String(Date.now()));
          } catch (error) {
            // No bloqueamos el envío si localStorage no está disponible.
          }
        });
      }

      const hasResponseMessage = root.querySelector('.hn-popup__message');
      const hasSuccessMessage = root.querySelector('.hn-popup__message--success');
      if (hasSuccessMessage) {
        rememberSubscription();
        openPopup(true);
      } else if (hasResponseMessage) {
        openPopup(true);
      } else if (canShow()) {
        showTimer = window.setTimeout(openPopup, editorMode ? 150 : delay);
      }

      root._hnPopupCleanup = () => {
        if (showTimer) window.clearTimeout(showTimer);
        document.body.classList.remove('hn-popup-open');
      };
    };

    document.querySelectorAll('[data-hn-popup]').forEach(initPopup);

    document.addEventListener('shopify:section:load', (event) => {
      const popup = event.target.querySelector('[data-hn-popup]');
      if (popup) initPopup(popup);
    });

    document.addEventListener('shopify:section:select', (event) => {
      const popup = event.target.querySelector('[data-hn-popup]');
      if (!popup) return;
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hn-popup-open');
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      const popup = event.target.querySelector('[data-hn-popup]');
      if (!popup) return;
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hn-popup-open');
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const popup = event.target.querySelector('[data-hn-popup]');
      if (popup && typeof popup._hnPopupCleanup === 'function') {
        popup._hnPopupCleanup();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-imagen-sections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('hn-campaign-popup')) return;

    class HNCampaignPopup extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.overlay = this.querySelector('[data-hn-promo-overlay]');
        this.panel = this.querySelector('.hn-promo__panel');
        this.closeButton = this.querySelector('[data-hn-promo-close]');
        this.countdown = this.querySelector('[data-hn-countdown-output]');
        this.storageKey = `hnPromoSeen:${this.dataset.campaignKey || this.dataset.sectionId}`;

        this.onClick = this.handleClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onSectionSelect = this.handleSectionSelect.bind(this);
        this.addEventListener('click', this.onClick);
        document.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:section:select', this.onSectionSelect);

        if (this.dataset.enabled !== 'true') return;
        if (!this.prepareCountdown()) return;

        const designMode = Boolean(window.Shopify?.designMode);
        const alreadySeen = this.dataset.oncePerSession === 'true' && this.readSeen();
        if (designMode || !alreadySeen) {
          const delay = designMode ? 150 : Math.max(0, Number(this.dataset.delay) || 0);
          this.openTimer = window.setTimeout(() => this.open(), delay);
        }
      }

      disconnectedCallback() {
        window.clearTimeout(this.openTimer);
        window.clearInterval(this.countdownTimer);
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:section:select', this.onSectionSelect);
        document.documentElement.classList.remove('hn-promo-lock');
      }

      readSeen() {
        try { return sessionStorage.getItem(this.storageKey) === '1'; }
        catch (_) { return false; }
      }

      rememberSeen() {
        if (this.dataset.oncePerSession !== 'true' || window.Shopify?.designMode) return;
        try { sessionStorage.setItem(this.storageKey, '1'); } catch (_) {}
      }

      prepareCountdown() {
        if (this.dataset.countdownEnabled !== 'true' || !this.countdown) return true;

        const date = this.dataset.endDate?.trim();
        const time = this.dataset.endTime?.trim() || '23:59';
        const offset = this.dataset.utcOffset?.trim() || '-06:00';
        this.endTime = new Date(`${date}T${time}:00${offset}`).getTime();

        if (Number.isNaN(this.endTime)) {
          if (window.Shopify?.designMode) {
            this.countdown.textContent = 'CONFIGURA LA FECHA';
            return true;
          }
          return false;
        }

        if (this.endTime <= Date.now() && this.dataset.hideWhenFinished === 'true' && !window.Shopify?.designMode) {
          return false;
        }

        this.updateCountdown();
        this.countdownTimer = window.setInterval(() => this.updateCountdown(), 1000);
        return true;
      }

      updateCountdown() {
        if (!this.endTime || !this.countdown) return;
        const remaining = Math.max(0, this.endTime - Date.now());
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        const pad = (value) => String(value).padStart(2, '0');

        this.querySelector('[data-hn-days]').textContent = pad(days);
        this.querySelector('[data-hn-hours]').textContent = pad(hours);
        this.querySelector('[data-hn-minutes]').textContent = pad(minutes);
        this.querySelector('[data-hn-seconds]').textContent = pad(seconds);
        this.countdown.setAttribute('aria-label', `${days} días, ${hours} horas, ${minutes} minutos y ${seconds} segundos`);

        if (remaining === 0) {
          window.clearInterval(this.countdownTimer);
          if (this.dataset.hideWhenFinished === 'true' && !window.Shopify?.designMode) this.close(false);
        }
      }

      open() {
        if (!this.hasAttribute('hidden') && this.classList.contains('is-open')) return;
        this.lastFocused = document.activeElement;
        this.hidden = false;
        document.documentElement.classList.add('hn-promo-lock');
        requestAnimationFrame(() => {
          this.classList.add('is-open');
          this.closeButton?.focus({ preventScroll: true });
        });
      }

      close(remember = true) {
        if (remember) this.rememberSeen();
        this.classList.remove('is-open');
        document.documentElement.classList.remove('hn-promo-lock');
        window.setTimeout(() => { this.hidden = true; }, 260);
        this.lastFocused?.focus?.({ preventScroll: true });
      }

      handleClick(event) {
        if (event.target === this.overlay || event.target.closest('[data-hn-promo-close]')) this.close();
        if (event.target.closest('[data-hn-promo-action]')) this.rememberSeen();
      }

      handleKeydown(event) {
        if (this.hidden || !this.classList.contains('is-open')) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;

        const focusable = [...this.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      handleSectionSelect(event) {
        if (event.target.contains(this)) this.open();
      }
    }

    customElements.define('hn-campaign-popup', HNCampaignPopup);
  })();

  } catch(e) { console.error(e); }
})();
})();
